import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
// import { notification } from 'antd'
import 'antd/dist/antd.css';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';

export class RouterTypeStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      routerTypes: [],
      offset: 0,
      limit: 15,
      search: null,
      sort: null,
      order: null,
      action: null,
      categories: [],
    });
  }

  setAction(task, data) {
    this[task] = data;
  }

  resetData() {
    this.offset = 0;
    this.limit = 15;
    this.search = null;
    this.sort = null;
    this.order = null;
    this.routerTypes = [];
  }

  async setData(task, data, getRouterType = true) {
    this[task] = data;
    if (getRouterType) {
      this.getRouterTypeList(this.offset, this.limit, this.search, this.sort, this.order);
    }
  }

  async getRouterTypeList(offset = 0, limit = 15, search = null, sort = null, order = null) {
    this.loading = true;
    let queryOption = {};
    queryOption.offset = offset;
    queryOption.limit = limit;
    if (search) {
      queryOption.search = search;
    }
    if (sort) {
      queryOption.sort = sort;
    }
    if (order) {
      queryOption.order = order;
    }
    try {
      let url = `${config.api.url}/${config.api.version}/routertype`;
      const res = await rp
        .get(url, {
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routerTypes = res.body || {};
        return (this.routerTypes = routerTypes);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async createRouterType(data) {
    this.loading = true;
    try {
      const detail = {
        name: data.name,
        manufacturer: data.manufacturer,
        description: data.description,
        contactPerson: data.contactPerson,
        address: data.address,
        tel: data.tel,
        email: data.email,
        imgUrl: data.imgUrl,
      };
      const res = await rp
        .post(`${config.api.url}/${config.api.version}/routertype`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async updateRouterType(data, task = null) {
    this.loading = true;
    try {
      const detail = {
        id: data.id,
        name: data.name,
        manufacturer: data.manufacturer,
        description: data.description,
        contactPerson: data.contactPerson,
        address: data.address,
        tel: data.tel,
        email: data.email,
        imgUrl: data.imgUrl,
      };
      const res = await rp
        .put(`${config.api.url}/${config.api.version}/routertype/${data.id}`, {
          body: detail,
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async deleteRouterType(id) {
    this.loading = true;
    try {
      const res = await rp
        .delete(`${config.api.url}/${config.api.version}/routertype/${id}`, {
          json: true,
          authorization: true,
          resolveWithFullResponse: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res && res.statusCode === 200) {
        return res;
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async findById(id) {
    this.loading = true;
    try {
      let url = `${config.api.url}/${config.api.version}/routertype/${id}`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        const routerTypes = res.body || {};
        return (this.routerTypes = routerTypes);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }

  async getCategory() {
    try {
      let url = `${config.api.url}/${config.api.version}/routertype/category/list`;
      const res = await rp
        .get(url, {
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));
      if (res.statusCode === 200) {
        let categories = res.body || [];
        return (this.categories = categories);
      }
    } catch (err) {
      throw err;
    } finally {
      this.loading = false;
    }
  }
}

export default new RouterTypeStore();
